import React from 'react';
import styled from 'styled-components';
import { Divider, Flex, Image } from 'antd';
import sponsorsData from '../awards_sponsor_data.json';
import { fonts } from '../assets/constStyles';

const IconStyled = styled(Image)`
  width: 200px;
  height: 70px;
  max-height: 70px;
  object-fit: cover;
`;

const DivStyled = styled(Flex)`
  padding: 10px;
  position: relative;
  gap: 40px;
  flex-direction: column;

  && * {
    font-family: ${fonts.font2} !important;
  }
  
  @media (max-width: 768px) {
    padding: 5px;
    gap: 10px;
  }
`;

const PStyled = styled.p`
  font-size: 1.3em;
  font-weight: bolder;

  @media (max-width: 768px) {
    font-size: 0.7em;
  }
`;

export const SponsorsBlock: React.FC = () => {
  const keys = Array.from(Object.values(sponsorsData));

  return (
        <DivStyled>
            <Flex vertical gap={5} style={{ textAlign: 'center' }}>
                {/* <Image src={'/img/logo34.webp'} preview={false} /> */}
                <PStyled>THANK YOU TO OUR SPONSORS</PStyled>
            </Flex>
            {
                keys.map((sponsor, index) => (
                <Flex vertical key={index} gap={60} justify={'center'}>
                    <PStyled>{sponsor.caption}</PStyled>
                        {sponsor.logos.map((logo, indexn) => (
                            <Flex key={indexn} justify={'center'}>
                                <IconStyled src={`/img/sponsors/${logo.img}`} preview={false}/>
                            </Flex>
                        ))}
                    <Divider />
                </Flex>
                ))}
        </DivStyled>
  );
};
